import { PlusOutlined } from "@ant-design/icons";
import { Button, Drawer, Form, Input, InputNumber, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import axios from "axios";
import { useState } from "react";

const CreateArticleDrawer = ({
  token,
  handleSearch,
  onSelect,
  newArticleName,
}) => {
  const [open, setOpen] = useState(false);
  const [form] = useForm();

  const handleSubmit = async (values) => {
    axios
      .post(
        `https://${process.env.REACT_APP_APP_URL}/api/v1/articles/?token=${token}`,
        values
      )
      .then((res) => {
        setOpen(false);
        form.resetFields();
        handleSearch("");
        onSelect(res.data.id);
      })
      .catch((err) => console.log(err));
  };
  return (
    <div>
      <Button icon={<PlusOutlined />} onClick={() => setOpen(true)} />
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        title="Создание статьи"
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            initialValue={newArticleName}
            style={{ marginBottom: 12 }}
            label="Название"
            name="name"
          >
            <Input />
          </Form.Item>
          <Form.Item style={{ marginBottom: 12 }} label="Эмодзи" name="emoji">
            <Input />
          </Form.Item>
          <Form.Item style={{ marginBottom: 12 }} label="Код" name="code">
            <InputNumber />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: 12 }}
            label="Описание"
            name="description"
          >
            <Input />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: 12 }}
            label="Расходы"
            name="expenses_for"
          >
            <Select>
              <Select.Option value="При приобретении">
                При приобретении
              </Select.Option>
              <Select.Option value="В иных процессах">
                В иных процессах
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            style={{ marginBottom: 12 }}
            label="Распределение"
            name="distribute_for"
          >
            <Select>
              <Select.Option value="На себестоимость товаров">
                На себестоимость товаров
              </Select.Option>
              <Select.Option value="На расходы текущего периода">
                На расходы текущего периода
              </Select.Option>
              <Select.Option value="На расходы будущего периода">
                На расходы будущего периода
              </Select.Option>
              <Select.Option value="Распредилить вручную">
                Распредилить вручную
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            style={{ marginBottom: 12 }}
            label="Основание для распределения"
            name="distribute_according"
          >
            <Select>
              <Select.Option value="Себестоимость">Себестоимость</Select.Option>
              <Select.Option value="Расходы">Расходы</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item style={{ marginBottom: 12 }} label="Статус" name="dc">
            <Select>
              <Select.Option value="debit">Приход</Select.Option>
              <Select.Option value="credit">Расход</Select.Option>
            </Select>
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", marginTop: 12 }}
          >
            Создать
          </Button>
        </Form>
      </Drawer>
    </div>
  );
};

export default CreateArticleDrawer;
